// extracted by mini-css-extract-plugin
export default {"menu_container":"MenuTabs_menu_container__v1UXr","menu":"MenuTabs_menu__xjrlI"};